import { combineReducers } from 'redux';

import AppReducer from '../components/app/app.reducer';
import login from '../components/login/login.reducer';
import courses from '../components/courses/courses.reducer';
import classes from '../components/classes/classes.reducer';
import tccs from '../components/tccs/tccs.reducer';
import onlineTests from '../components/online-tests/online-tests.reducer';
import questionsDatabase from '../components/questions-database/questions-database.reducer';
import manageQuestion from '../components/manage-question/manage-question.reducer';
import addQuestion from '../components/add-question/add-question.reducer';
import tests from '../components/tests/tests.reducer';
import testsConducted from '../components/tests-conducted/tests-conducted.reducer';
import users from '../components/users/users.reducer';
import notifications from '../components/notifications/notifications.reducer';
import trainers from '../components/trainers/trainers.reducer';
import global from '../components/global/global.reducer';
import centers from '../components/centers/centers.reducer';
import admins from '../components/admins/admins.reducer';
import addTemplateTest from '../components/add-template-test/add-template-test.reducer';
import manageTemplateTest from '../components/manage-template-test/manage-template-test.reducer';
import duplicateTemplateTest from '../components/duplicate-template-test/duplicate-template-test.reducer';
import duplicateQuestion from '../components/duplicate-question/duplicate-question.reducer';

const rootReducer = combineReducers({
    App: AppReducer,
    login,
    courses,
    classes,
    tccs,
    users,
    notifications,
    trainers,
    global,
    centers,
    admins,
    onlineTests,
    questionsDatabase,
    manageQuestion,
    tests,
    testsConducted,
    addQuestion,
    addTemplateTest,
    manageTemplateTest,
    duplicateTemplateTest,
    duplicateQuestion,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/utils/root-reducer.js